export const MAX_MONEY_AMOUNT = 500000;

const moneyFormatter = new Intl.NumberFormat('nb-NO', {
  style: 'currency',
  currency: 'NOK',
  maximumFractionDigits: 0,
});

const numberFormatter = new Intl.NumberFormat('nb-NO', {
  maximumFractionDigits: 0,
  useGrouping: true,
});

function sanitizeAmountInput(value: string): string {
  return value
    .trim()
    .replace(/[\s\u00A0\u202F]/g, '')
    .replace(',', '.');
}

function clampAmount(value: number, max = MAX_MONEY_AMOUNT): number {
  if (!Number.isFinite(value)) {
    return 0;
  }

  const amount = Math.trunc(value);

  if (amount <= 0) {
    return 0;
  }

  return Math.min(amount, max);
}

export function clampAmountInputValue(value: string, max = MAX_MONEY_AMOUNT): string {
  const normalized = sanitizeAmountInput(value);

  if (normalized === '') {
    return '';
  }

  const parsed = Number(normalized);
  return Number.isNaN(parsed) ? '' : String(clampAmount(parsed, max));
}

export function parseAmountInput(value: string, max = MAX_MONEY_AMOUNT): number {
  const normalized = sanitizeAmountInput(value);

  if (normalized === '') {
    return 0;
  }

  const parsed = Number(normalized);
  return Number.isNaN(parsed) ? 0 : clampAmount(parsed, max);
}

export function formatAmount(value: number): string {
  const amount = Number.isFinite(value) ? value : 0;
  return moneyFormatter.format(amount).replace(/[\s\u00A0\u202F]/g, '\u00A0');
}

export function formatAmountInput(value: number | string, max = MAX_MONEY_AMOUNT): string {
  const normalized = typeof value === 'number'
    ? String(value)
    : sanitizeAmountInput(value);

  if (normalized === '') {
    return '';
  }

  const parsed = Number(normalized);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return '';
  }

  const amount = clampAmount(parsed, max);
  if (amount <= 0) {
    return '';
  }

  return numberFormatter.format(amount).replace(/[\s\u00A0\u202F]/g, '\u00A0');
}
